import type {BuildId} from '../../../../types'
import {parseExpandState} from '../../../packages/BuildLog/BuildLog.utils'
import {updateFullLogState} from '../../../packages/BuildLog/FullBuildLog/FullBuildLog.actions'

export const changePageFullLogBuildId = (buildId: BuildId | null | undefined) =>
  updateFullLogState({
    target: 'page',
    buildId,
  })
export const resetPageFullLog = () =>
  updateFullLogState({
    target: 'page',
    buildId: null,
    focusLine: null,
    expandState: null,
  })
export const setLinesState = (lines: string | null | undefined) =>
  updateFullLogState({
    target: 'page',
    expandState: parseExpandState(lines) as ReadonlyArray<number> | null | undefined,
  })
export const setExpandAll = (value: boolean) =>
  updateFullLogState({
    target: 'page',
    expandAll: value,
  })
export const setFocusLine = (focusLine: number | null | undefined) =>
  updateFullLogState({
    target: 'page',
    focusLine: Number(focusLine) as number,
  })
